// export const environment = {
//   production: false,
//   isDebugMode: true,
//   baseUrl: 'https://dev.insightgainer.com',
//   mediaServiceUrl: 'https://dev.insightgainer.com/services/media/api/v1',
//   billingServiceUrl: 'https://dev.insightgainer.com/services/billing/api/v1',
//   notificationUrl: 'https://dev.insightgainer.com/services/notification/api/v1',
//   identityUrl: 'https://dev.insightgainer.com/services/identity/api/v1',
//   seoUrl: 'https://dev.insightgainer.com/services/seo/api/v1',
//   cognitiveServiceUrl: 'https://dev.insightgainer.com/services/cognitive/api/v1',
//   paymentReturnUrl: 'https://dev.insightgainer.com/billing/payment-results',
//   googleOAuthRedirectUrl: 'https://dev.insightgainer.com/settings/manage/projects',
//   auditServicesUrl :'https://dev.insightgainer.com/api/v1/AuditLog'
// };

export const environment = {
  production: false,
  isDebugMode: true,
  baseUrl: 'https://dev.insightgainer.com',
  mediaServiceUrl: 'https://dev-mediaapi.insightgainer.com/api/v1',
  billingServiceUrl: 'https://dev-billingapi.insightgainer.com/api/v1',
  notificationUrl: 'https://dev-notificationapi.insightgainer.com/api/v1',
  identityUrl: 'https://dev-identityapi.insightgainer.com/api/v1',
  seoUrl: 'https://dev-seoapi.insightgainer.com/api/v1',
  cognitiveServiceUrl: 'https://dev-cognitiveapi.insightgainer.com/api/v1',
  crawlerServiceUrl: 'https://dev-crawlerapi.insightgainer.com/api/v1',
  paymentReturnUrl: 'https://dev.insightgainer.com/billing/payment-results',
   googleOAuthRedirectUrl: 'https://dev.insightgainer.com/settings/manage/projects',
  auditServicesUrl :'https://dev.insightgainer.com/api/v1/AuditLog',
  externalAuthCallbackUrl: 'https://dev.insightgainer.com/account/callback',
  googleOAuthClientId: '828410890108-03ukmg4pvvofbkife1p7eirtq0ptnmj2.apps.googleusercontent.com',
  microsoftOAuthClientId: '79492016-b27b-417f-9a54-2b0defa3be40',
  googleMapsStaticApiKey: 'AIzaSyA9nMjqq8bCHvEWEZcAchHz18eo5TFeI-8'
};
